
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightEmergencyOff as ObiLightEmergencyOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-emergency-off.js';
 
 
 

 
 export const ObiLightEmergencyOff = createComponent({
   react: React,
   tagName: 'obi-light-emergency-off',
   elementClass: ObiLightEmergencyOffElement,
   events: {
     
   }
  });
 
 